module.exports = __webpack_public_path__ + "static/media/roboto-mono-v5-latin-700italic.7324e30e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/roboto-mono/roboto-mono-v5-latin-700italic.woff
// module id = 492
// module chunks = 0